import axios from "@/common/axios";

// 新增学生信息登记
export const addstu = (params) => {
  return axios.post("/business/registration/add", params);
};
// 中职学生报名登记
export const addcenstu = (params) => {
  return axios.post("/business/registration/vocationalSchoolsAdd", params);
};
// 登记信息获取当前学校与班级信息
export const getSchoolClass = (params) => {
  return axios.get("/business/registration/obtainSchoolClass");
};
// 获取中职学校与专业信息
export const getcenterSchoolClass = (params) => {
  return axios.get("/business/registration/ObtainingProfessionalInformation");
};
// 获取学生登记信息
export const getStudent = (params) => {
  return axios.get(
    "/business/registration/getStudent" +
      "?idCard=" +
      params.idno +
      "&studentName=" +
      params.name +
      "&phone=" +
      params.phone +
      "&code=" +
      params.code
  );
};
// 获取中职学生报名登记信息
export const getcenterStudent = (params) => {
  return axios.get(
    "/business/registration/getObtainingStudentInfo" +
      "?idCard=" +
      params.idno +
      "&name=" +
      params.name +
      "&admissionTicketNumber=" +
      params.code
  );
};
// 中考成绩查询
export const getgrades = (params) => {
  return axios.get(
    "/business/registration/grades" +
      "?idCard=" +
      params.idno +
      "&ticketNumber=" +
      params.code
  );
};
// 获取学生信息
export const getStu = (params) => {
  return axios.get(
    "/business/registration/getObtainingStudentInfoConfirm" +
      "?idCard=" +
      params.idno +
      "&studentName=" +
      params.name
  );
};
// 获取高中录取结果学校名称
export const getgzlq = (params) => {
  return axios.get(
    "/business/registration/highSchoolResults" +
      "?idCard=" +
      params.idno +
      "&studentName=" +
      params.name +
      "&phone=" +
      params.phone +
      "&code=" +
      params.code
  );
};
// 获取中职录取结果学校名称
export const getzzlq = (params) => {
  return axios.get(
    "/business/registration/highSchoolResults" +
      "?idCard=" +
      params.idno +
      "&studentName=" +
      params.name +
      "&admissionTicketNumber=" +
      params.code
  );
};
// 获取配置开放信息接口
export const getsarend = (params) => {
  return axios.get("/business/registration/getConfig");
};
// ------------------------------登录版本接口------------------------------------------------//
// 登录
export const login = (params) => {
  return axios.post("/page/register/login", params);
};
// 重置密码
export const czpass = (params) => {
  return axios.post("/page/register/updatePassWord", params);
};
// 获取民族
export const getNation = (params) => {
  return axios.get("/page/getNation");
};
//获取语种
export const getLanguage = (params) => {
  return axios.get("/page/getLanguage");
};
// 获取毕业学校
export const getschool = (params) => {
  return axios.get("/page/czSchoolList");
};
// 学生信息登记
export const addUser = (params) => {
  return axios.post("/page/editUser", params);
};
// 获取学生信息
export const getUserInfo = (params) => {
  return axios.get("/page/getUserInfo" + "?bmNumber=" + params.id);
};
// 获取第一批次第二批次学校接口
export const getBatchSchools = (params) => {
  return axios.get("/page/getBatchSchools/" + params.batch);
};
// 查询学生高中录取情况
export const getByStudentId = (params) => {
  return axios.get("/page/getByStudentId/" + params.id);
};
// 高中志愿填报
export const addhigh = (params) => {
  return axios.post("/page/submitVolunteer", params);
};
// 获取配置开放信息接口
export const getsarends = (params) => {
  return axios.get("/page/getConfig");
};
// 高考成绩查询
export const getgradess = (params) => {
  return axios.get("/page/getStudentInfo/" + params.id);
};
// 获取中职学校集合
export const getinzhilist = (params) => {
  return axios.get("/business/page/BPageSecondaryVocational/getVocationalList");
};
// 获取五年一贯制学校集合
export const getgaozhilist = (params) => {
  return axios.get(
    "/business/page/BPageSecondaryVocational/getFiveVocationalList"
  );
};
// 中职学校填报
export const addinzhi = (params) => {
  return axios.post("/business/page/BPageSecondaryVocational/add", params);
};
// 获取中职录取查询
export const getinzhilq = (params) => {
  return axios.get(
    "/business/page/BPageSecondaryVocational/getAdmissionResultsVocational" +
      "?studentId=" +
      params.studentId
  );
};
// 获取准考证号
export const getStudentAdmission = (params) => {
  return axios.post("/page/getStudentAdmission", params);
};
//获取中职已填报志愿
export const getinzhizy = (params) => {
  return axios.get(
    "/business/page/BPageSecondaryVocational/getFillInDetails" +
      "?studentId=" +
      params.studentId
  );
};
//获取高中已填报志愿
export const gethighzy = (params) => {
  return axios.get(
    "/page/getHighSchoolFillInDetails" + "?studentId=" + params.studentId
  );
};
//获取中职类别
export const getinzhitype = (params) => {
  return axios.get("/business/page/BPageSecondaryVocational/getBmType");
};

//获取该学生上一年的信息
export const getLastRegInfo = (params) => {
  return axios.get("/page/getLastRegInfo" + "?bmNumber=" + params.id);
};
